import { apiClient } from '@/shared/lib/axios';
import { ClinicsListResponse } from './types';

export type ClinicsListParams = {
  search_clinic_number?: string;
  available_date?: string;
  site_types?: string[];
  sort?: [string, 'asc' | 'desc'];
  page?: number;
  per_page?: number;
};

export const getClinics = async (site: string, params: ClinicsListParams): Promise<ClinicsListResponse> => {
  const response = await apiClient.get<ClinicsListResponse>(`/admin/${site}/clinics`, { params });
  return response.data;
};

export const getAllClinics = async (siteType: string, params: ClinicsListParams): Promise<ClinicsListResponse> => {
  const response = await apiClient.get<ClinicsListResponse>(`/admin/${siteType}/clinics`, { params });
  return response.data;
};

export const downloadClinicsCsv = async (site: string, params: ClinicsListParams): Promise<void> => {
  const response = await apiClient.get(`/admin/${site}/clinics/csv`, {
    params,
    responseType: 'blob',
  });

  const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `clinic${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadAllClinicsCsv = async (siteType: string, params: ClinicsListParams): Promise<void> => {
  const response = await apiClient.get(`/admin/${siteType}/clinics/csv`, {
    params,
    responseType: 'blob',
  });

  const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `clinic${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const deleteClinic = async (site: string, id: number): Promise<{ success: boolean; message?: string }> => {
  const response = await apiClient.delete<{ success: boolean; message?: string }>(`/admin/${site}/clinics/${id}`);
  return response.data;
};

export type ClinicOption = {
  id: number;
  clinic_number: string;
  name: string;
  site_type?: string | null;
  /** Clinic service_type: 'r2' | 'a2' | 'both' | null */
  service_type?: string | null;
};

export const getClinicOptions = async (siteType: string): Promise<ClinicOption[]> => {
  const response = await apiClient.get<{ success: boolean; data: ClinicOption[] }>(`/admin/${siteType}/clinics/options`);
  return response.data.data;
};

export type ClinicOptionPage = {
  data: ClinicOption[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
};

export const getClinicOptionsPaginated = async (
  siteType: string,
  params: { tenant_ids?: number[]; page: number; per_page?: number }
): Promise<ClinicOptionPage> => {
  const response = await apiClient.get<{ success: boolean; data: ClinicOptionPage }>(
    `/admin/${siteType}/clinics/options`,
    { params: { ...params, per_page: params.per_page ?? 20 } }
  );
  return response.data.data;
};
